import styled from 'styled-components';
import { Color } from '../common/base';

const LegalSubtitle = styled.p`
  color: ${Color.blackLight};
  text-transform: uppercase;
  font-size: 12px;
`;

const LegalDesc = styled.div`
  font-size: 18px;
  margin-top: 32px;
  color: ${Color.blackMediumLight};
`;

const LegalHeader = styled.h4`
  color: ${Color.black};
`;

const LegalList = styled.ul`
  margin-left: 15px;
  padding: 10px;
`;

export { LegalSubtitle, LegalDesc, LegalHeader, LegalList };
